import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  image: {
    background: props => props?.texture ? `no-repeat center/cover url(${props.texture}) !important` : (props?.bgColor !== 'transparent' && `${props?.bgColor} !important`),
    backgroundSize: 'center',
  },
});

export default useStyles;
